import { makeStyles } from "@material-ui/core";
import { ocean } from "../../../../hooks/use-map-theme-styles";

export default makeStyles(({ spacing }) => ({
	root: {
		flexGrow: 1,
	},
	title: {
		fontSize: "24px",
		fontWeight: 600,
		color: ocean,
	},
	container: {
		padding: spacing(2),
		paddingLeft: spacing(4),
		paddingRight: spacing(4),
		overflowY: "hidden",
		maxHeight: "448px",
	},
	scrollableContainer: {
		overflowY: "auto",
		maxHeight: "480px",
	},
	inboxScrollableContainer: {
		maxHeight: "486px",
		overflowY: "auto",
	},
	goToTaskContainer: {
		display: "flex",
		justifyContent: "center",
		borderRadius: "15px",
		backgroundColor: "#c8daf4",
		color: "#367bf5",
		cursor: "pointer",
	},
	goToTaskContainerWrap: {
		display: "flex",
		justifyContent: "end",
		margin: "8px 0",
		height: "24px",
		visibility: "visible",
		marginLeft: "auto",
	},
	infoIcon: {
		marginLeft: "3px",
		verticalAlign: "top",
		width: "16px",
		color: "#367bf5",
	},
	showClass: {
		display: "flex",
		justifyContent: "center",
		width: "18%",
		margin: "10px 0px 8px 8px",
		borderRadius: "15px",
		height: "25px",
		backgroundColor: "#99e6ff",
	},
	hideClass: {
		display: "none",
		justifyContent: "center",
		width: "18%",
		margin: "10px 0px 8px 8px",
		borderRadius: "15px",
		height: "25px",
		backgroundColor: "#99e6ff",
	},
	task: {
		fontSize: 14,
		padding: "0 24px 0 8px",
		color: "#212121",
	},
	questContent: {
		fontSize: 14,
		paddingLeft: "8px",
		color: "#212121",
	},
	isReadDot: {
		minWidth: "8px",
		width: "8px",
		height: "8px",
		marginRight: 8,
		backgroundColor: "#ed544d",
		borderRadius: 15,
	},
	iconButton: {
		"&.MuiIconButton-root": {
			padding: "8px",
			backgroundColor: "transparent",
		},
	},
	iconQuest: {
		width: "24px",
		height: "24px",
		marginLeft: "24px",
		"&.MuiIconButton-root:hover ": {
			backgroundColor: "#cfdff4",
		},
	},
	expandedQuestContent: {
		paddingRight: "24px",
		marginBottom: "32px",
	},
	accordionSummary: {
		"&.MuiAccordionSummary-root": {
			padding: 0,
			minHeight: "40px",
		},
		"& .MuiAccordionSummary-content": {
			margin: 0,
		},
		"&.MuiAccordionSummary-root.Mui-expanded": {
			minHeight: "40px",
		},
	},
	contentSeparator: {
		display: "inline-block",
		margin: "2px 8px",
		width: 4,
		height: 4,
		borderRadius: "50%",
		backgroundColor: "#367bf5",
	},
}));
